import cmp from './DecisionMechanism'

export default cmp
